//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { CalendarConflictCheckSearchOptions } from './CalendarConflictCheckSearchOptions';
import { RepeatDetailsItem } from './RepeatDetailsItem';
import { CalendarEventUpdateStudentChangeMode } from './Enums';

export class CalendarUpdateEventCheckSearchOptions extends ItemBase {
    StudentChangeMode: CalendarEventUpdateStudentChangeMode = CalendarEventUpdateStudentChangeMode.Absolute;
    StudentIDs: string[] = [];
    ConflictCheckSearchOptions: CalendarConflictCheckSearchOptions | null = null;
    RepeatDetailsToUseForUpdate: RepeatDetailsItem | null = null;
    TeacherID: string | null = null;
    OriginalTeacherID: string | null = null;
    UpdateFutureEvents: boolean = false;

    constructor(initializer?: Partial<CalendarUpdateEventCheckSearchOptions>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "CalendarUpdateEventCheckSearchOptions";
}
